import type { Variables } from "@/lib/sparxs/metadataSchemas";
import type { PickerListItem } from "@/features/sparxsEditor/components/molecules/pickerList/pickerList";

const variableToItem = (v: Variables): PickerListItem => ({
  raw: v.name,
  label: v.name,
});

const mapVariablesToPickerItems = (variables: Variables[]): PickerListItem[] =>
  variables.map(variableToItem);

const filterPickerItemsByQuery = (
  items: PickerListItem[],
  query: string,
): PickerListItem[] => {
  const trimmed = query.trim();
  if (!trimmed) return items;
  const q = trimmed.toLowerCase();
  return items.filter(
    (item) =>
      item.label.toLowerCase().includes(q) ||
      item.raw.toLowerCase().includes(q),
  );
};

export const filterVariablesPickerItemsByQuery = (
  variables: Variables[],
  query: string,
): PickerListItem[] =>
  filterPickerItemsByQuery(mapVariablesToPickerItems(variables), query);

export const filterVariablesByDirective = (
  variables: Variables[],
  directiveTypes: string[],
): Variables[] =>
  variables.filter((v) => v.type != null && directiveTypes.includes(v.type));
